"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniSearchHotkeysFeature = OmniSearchHotkeysFeature;
const registeredFileSearch_1 = require("@branch-ts/biome-media-web/src/file/registeredFileSearch");
const web_consensus_1 = require("@branch-ts/web-consensus");
function OmniSearchHotkeysFeature(config) {
    const fileSearch = new registeredFileSearch_1.RegisteredFileSearch({
        ignores: [".git", "node_modules", ".DS_Store", "backup", ".config", ".local", ".cache", ".cursor-server", "dump"],
    });
    const hotkeys = web_consensus_1.HotkeyManager.global.solution;
    hotkeys.register({
        key: "<mod><alt><shift>o",
        handle: () => {
            const fastSearchHud = config.omniCenter.createFastSearchHud({
                allowContinuousSelect: false,
            });
            fastSearchHud.select().then((anchor) => {
                web_consensus_1.UIMechanism.goto({
                    uri: anchor.essenceURI,
                });
            });
            return true;
        },
    });
    hotkeys.register({
        key: "<alt>u",
        handle: () => {
            const fastSearchHud = fileSearch.createHud();
            if (!fastSearchHud)
                return false;
            fastSearchHud.select().then((anchor) => {
                web_consensus_1.UIMechanism.goto({
                    uri: anchor.essenceURI,
                });
            });
            return true;
        },
    });
}
